const einvoicing = {
  // ==================== E-INVOICING ====================
  'einvoicing.title': 'E-Invoicing',
  'einvoicing.subtitle': 'Eingangsrechnungen digital erfassen, prüfen und mit Bestellungen abgleichen',
  'einvoicing.inDevelopmentDesc': 'Das E-Invoicing-Modul wird die digitale Erfassung und Verarbeitung von Eingangsrechnungen, den automatischen Abgleich mit Bestellungen und Wareneingängen sowie die Weiterleitung in den Genehmigungsprozess ermöglichen.',

  // Navigation
  'einvoicing.navDashboard': 'Dashboard',
  'einvoicing.navInbox': 'Posteingang',
  'einvoicing.navOutbound': 'Postausgang',
  'einvoicing.navCoverage': 'Länder & Formate',

  // Dashboard
  'einvoicing.kpiNeedsAction': 'Handlungsbedarf',
  'einvoicing.kpiValidationFailed': 'Validierung fehlgeschlagen',
  'einvoicing.kpiDueSoon': 'Fällig in 7 Tagen',
  'einvoicing.kpiOutboundOpen': 'Ausgang offen',
  'einvoicing.dashVolume': 'Belegvolumen (12 Monate)',
  'einvoicing.dashFunnel': 'Status-Übersicht Eingang',
  'einvoicing.dashRegimes': 'Länderabdeckung',
  'einvoicing.dashRecent': 'Letzte Aktivität',
  'einvoicing.dashEmpty': 'Noch keine Belege vorhanden.',
  'einvoicing.dashLoadError': 'Dashboard konnte nicht geladen werden',
  'einvoicing.funnelInProcess': 'In Bearbeitung',
  'einvoicing.funnelError': 'Fehler / abgelehnt',
  'einvoicing.funnelComplete': 'Abgeschlossen',
  'einvoicing.inbound': 'Eingang',
  'einvoicing.outbound': 'Ausgang',
  'einvoicing.loading': 'Lädt …',

  // Liste
  'einvoicing.searchPlaceholder': 'Nummer oder Partner suchen …',
  'einvoicing.allStates': 'Alle Status',
  'einvoicing.needsActionOnly': 'Nur Handlungsbedarf',
  'einvoicing.uploadButton': 'Rechnung hochladen',
  'einvoicing.listEmpty': 'Keine Rechnungen gefunden.',
  'einvoicing.listLoadError': 'Liste konnte nicht geladen werden',
  'einvoicing.uploadOk': 'Rechnung importiert ({format})',
  'einvoicing.uploadError': 'Upload fehlgeschlagen',
  'einvoicing.uploadValidationFailed': 'Import mit {n} Validierungsfehlern — bitte prüfen',
  'einvoicing.colNumber': 'Nummer',
  'einvoicing.colCounterparty': 'Partner',
  'einvoicing.colIssueDate': 'Rechnungsdatum',
  'einvoicing.colDueDate': 'Fällig',
  'einvoicing.colAmount': 'Betrag',
  'einvoicing.colFormat': 'Format',
  'einvoicing.colStatus': 'Status',
  'einvoicing.colMatch': 'Abgleich',
  'einvoicing.noNumber': '(ohne Nummer)',

  // Business-Status (Spur 1)
  'einvoicing.state.received': 'Eingegangen',
  'einvoicing.state.validated': 'Validiert',
  'einvoicing.state.validation_failed': 'Validierung fehlgeschlagen',
  'einvoicing.state.in_approval': 'In Freigabe',
  'einvoicing.state.approved': 'Freigegeben',
  'einvoicing.state.rejected': 'Abgelehnt',
  'einvoicing.state.posted_to_sap': 'In SAP gebucht',
  'einvoicing.state.archived': 'Archiviert',
  'einvoicing.state.draft': 'Entwurf',
  'einvoicing.state.generated': 'Generiert',
  'einvoicing.state.sent': 'Versendet',

  // Transport-Status (Spur 2)
  'einvoicing.transport.received': 'Empfangen',
  'einvoicing.transport.delivered': 'Zugestellt',
  'einvoicing.transport.submitted': 'Übermittelt',
  'einvoicing.transport.upo_received': 'UPO erhalten',
  'einvoicing.chip.business': 'Business-Status (Workflow)',
  'einvoicing.chip.transport': 'Transport-/Behördenstatus',

  // Abgleich
  'einvoicing.match.matched': 'BANF zugeordnet',
  'einvoicing.match.partial': 'Teilweise (prüfen)',
  'einvoicing.match.no_match': 'Keine BANF gefunden',
  'einvoicing.match.unavailable': 'Abgleich nicht verfügbar',

  // Detail
  'einvoicing.seller': 'Verkäufer',
  'einvoicing.buyer': 'Käufer',
  'einvoicing.vatId': 'USt-IdNr.',
  'einvoicing.taxNumber': 'Steuernummer',
  'einvoicing.orderRef': 'Bestellreferenz',
  'einvoicing.buyerRef': 'Käuferreferenz (Leitweg-ID)',
  'einvoicing.linePos': 'Pos.',
  'einvoicing.lineName': 'Bezeichnung',
  'einvoicing.lineQty': 'Menge',
  'einvoicing.linePrice': 'Einzelpreis',
  'einvoicing.lineVat': 'USt.',
  'einvoicing.lineTotal': 'Netto',
  'einvoicing.totalNet': 'Netto gesamt',
  'einvoicing.totalVat': 'Umsatzsteuer',
  'einvoicing.totalPayable': 'Zahlbetrag',
  'einvoicing.files': 'Dateien (Original = rechtliches Artefakt)',
  'einvoicing.fileKind.original': 'Original',
  'einvoicing.fileKind.generated': 'Generiert',
  'einvoicing.fileKind.validation-report': 'Prüfbericht',
  'einvoicing.fileKind.attachment': 'Anhang',
  'einvoicing.retentionUntil': 'Aufbewahrung bis',
  'einvoicing.pdfView': 'PDF-Ansicht',
  'einvoicing.pdfShow': 'Anzeigen',
  'einvoicing.pdfHide': 'Ausblenden',
  'einvoicing.pdfViewNote': 'Sichtkopie — rechtlich maßgeblich ist das maschinenlesbare XML. Der erzeugte PDF-Umschlag ist noch ohne PDF/A-3-Zertifizierung.',
  'einvoicing.actions': 'Aktionen',
  'einvoicing.approve': 'Freigeben',
  'einvoicing.reject': 'Ablehnen',
  'einvoicing.commentPlaceholder': 'Kommentar (bei Ablehnung Pflicht) …',
  'einvoicing.rejectNeedsComment': 'Ablehnung erfordert einen Kommentar.',
  'einvoicing.approvedMsg': 'Rechnung freigegeben',
  'einvoicing.rejectedMsg': 'Rechnung abgelehnt',
  'einvoicing.postToSap': 'In SAP buchen (MM-LIV)',
  'einvoicing.postedMsg': 'In SAP gebucht',
  'einvoicing.sapDocNo': 'SAP-Belegnummer',
  'einvoicing.generate': 'Generieren',
  'einvoicing.generatedMsg': 'Datei generiert und archiviert',
  'einvoicing.markSent': 'Als versendet markieren',
  'einvoicing.sentMsg': 'Als versendet markiert',
  'einvoicing.validation': 'Validierung',
  'einvoicing.validationOk': 'Kernvalidierung bestanden',
  'einvoicing.validationCoreNote': 'Portal-Kernregeln; amtliche Schematron-Prüfung folgt per Sidecar',
  'einvoicing.matching': 'BANF-Abgleich',
  'einvoicing.rematch': 'Abgleich neu ausführen',
  'einvoicing.timeline': 'Verlauf',

  // Events
  'einvoicing.event.received': 'Rechnung eingegangen',
  'einvoicing.event.validation_passed': 'Validierung bestanden',
  'einvoicing.event.validation_failed': 'Validierung fehlgeschlagen',
  'einvoicing.event.matched': 'BANF-Abgleich ausgeführt',
  'einvoicing.event.approved': 'Freigegeben',
  'einvoicing.event.rejected': 'Abgelehnt',
  'einvoicing.event.posted_to_sap': 'In SAP gebucht',
  'einvoicing.event.sap_post_failed': 'SAP-Buchung fehlgeschlagen',
  'einvoicing.event.draft_created': 'Entwurf angelegt',
  'einvoicing.event.generated': 'Datei generiert',
  'einvoicing.event.sent': 'Versendet',

  // Ausgang
  'einvoicing.sapBillingDocs': 'SAP-Fakturen (Adapter)',
  'einvoicing.sapBillingDocsHint': 'Quelle: SAP-Adapter-Naht (heute Mock, später Konstantins Echtadapter). Beleg wählen → Portal-Entwurf → Format generieren.',
  'einvoicing.createDraft': 'Entwurf anlegen',
  'einvoicing.draftCreatedMsg': 'Ausgangs-Entwurf angelegt',

  // Länder & Formate
  'einvoicing.coverageTitle': 'Regime-Abdeckung (8 Länder)',
  'einvoicing.coverageHint': 'Verifiziert = Rechtslage durch adversarial geprüfte Recherche bestätigt (Stand 07/2026). Unverifizierte Regime: keine Compliance-Zusagen.',
  'einvoicing.covCountry': 'Land',
  'einvoicing.covModel': 'Modell',
  'einvoicing.covFormats': 'Formate',
  'einvoicing.covChannels': 'Kanäle',
  'einvoicing.covSigning': 'Signatur',
  'einvoicing.covArchive': 'Aufbewahrung',
  'einvoicing.covStatus': 'Rechtsstand',
  'einvoicing.covMandates': 'Pflichten & Termine',
  'einvoicing.years': 'Jahre',
  'einvoicing.regimeVerified': 'verifiziert',
  'einvoicing.regimeUnverified': 'UNVERIFIZIERT',
  'einvoicing.signing.none': 'keine (internes Kontrollverfahren)',
  'einvoicing.signing.session': 'Session-Auth (Zertifikat)',
  'einvoicing.signing.per-invoice-b2g': 'B2G: qualifizierte Signatur je Datei',
  'einvoicing.signing.platform': 'Plattform (PA) trägt Compliance',
  'einvoicing.signing.verifactu-records': 'Hash-Kette + QR (Verifactu)',
  'einvoicing.signing.unknown': 'ungeklärt',

  // Werk (plant)
  'einvoicing.plant': 'Werk',
  'einvoicing.allPlants': 'Alle Werke',
  'einvoicing.colPlant': 'Werk',
  'einvoicing.plantUnassigned': '— nicht zugeordnet —',
  'einvoicing.plantSetMsg': 'Werk zugeordnet',
  'einvoicing.event.plant_set': 'Werk zugeordnet',

  // Ausgangsrechnung von Hand + Einstellungen
  'einvoicing.manual.create': 'Rechnung erfassen',
  'einvoicing.manual.title': 'Ausgangsrechnung erfassen',
  'einvoicing.manual.buyer': 'Käufer',
  'einvoicing.manual.buyerName': 'Name / Firma',
  'einvoicing.manual.vatId': 'USt-IdNr.',
  'einvoicing.manual.taxNumber': 'Steuernummer',
  'einvoicing.manual.street': 'Straße und Hausnummer',
  'einvoicing.manual.postCode': 'PLZ',
  'einvoicing.manual.city': 'Ort',
  'einvoicing.manual.country': 'Land (z. B. DE)',
  'einvoicing.manual.eAddress': 'E-Rechnungs-Adresse (E-Mail)',
  'einvoicing.manual.leitwegId': 'Leitweg-ID oder Ihre Referenz beim Kunden',
  'einvoicing.manual.paymentTerms': 'Zahlungsbedingungen',
  'einvoicing.manual.rate0': '0 % – Nullsatz (§12 Abs. 3 UStG)',
  'einvoicing.manual.vatHint': 'Steuerbefreite Umsätze und Reverse-Charge werden noch nicht unterstützt.',
  'einvoicing.manual.dueOrTermsHint': 'Fälligkeitsdatum oder Zahlungsbedingungen angeben.',
  'einvoicing.manual.dates': 'Rechnungsdaten',
  'einvoicing.manual.invoiceNumber': 'Rechnungsnummer',
  'einvoicing.manual.invoiceNumberHint': 'leer = nächste Nummer aus dem Nummernkreis',
  'einvoicing.manual.issueDate': 'Rechnungsdatum',
  'einvoicing.manual.deliveryDate': 'Leistungsdatum',
  'einvoicing.manual.dueDate': 'Fällig am',
  'einvoicing.manual.orderReference': 'Bestellnummer des Käufers',
  'einvoicing.manual.currency': 'Währung',
  'einvoicing.manual.lines': 'Positionen',
  'einvoicing.manual.lineName': 'Bezeichnung',
  'einvoicing.manual.quantity': 'Menge',
  'einvoicing.manual.unit': 'Einheit',
  'einvoicing.manual.netPrice': 'Einzelpreis netto',
  'einvoicing.manual.vatRate': 'USt.',
  'einvoicing.manual.lineNet': 'Netto',
  'einvoicing.manual.addLine': 'Position hinzufügen',
  'einvoicing.manual.removeLine': 'Position entfernen',
  'einvoicing.manual.totalNet': 'Netto gesamt',
  'einvoicing.manual.totalTax': 'Umsatzsteuer',
  'einvoicing.manual.totalGross': 'Gesamtbetrag',
  'einvoicing.manual.save': 'Entwurf anlegen',
  'einvoicing.manual.noSeller': 'Verkäuferdaten fehlen – ein Admin muss sie zuerst unter „Einstellungen“ hinterlegen.',
  'einvoicing.manual.unit.C62': 'Stück',
  'einvoicing.manual.unit.HUR': 'Stunde',
  'einvoicing.manual.unit.DAY': 'Tag',
  'einvoicing.manual.unit.KGM': 'kg',
  'einvoicing.manual.unit.MTR': 'Meter',
  'einvoicing.manual.unit.LS': 'pauschal',
  'einvoicing.settings.button': 'Einstellungen',
  'einvoicing.settings.title': 'E-Invoicing-Einstellungen',
  'einvoicing.settings.seller': 'Verkäufer (eigene Firma)',
  'einvoicing.settings.sellerHint': 'Erscheint auf jeder von Hand erfassten Ausgangsrechnung. USt-IdNr. oder Steuernummer, E-Rechnungs-Adresse, Ansprechpartner (Name, Telefon, E-Mail) und IBAN sind Pflicht (XRechnung).',
  'einvoicing.settings.contact': 'Ansprechpartner',
  'einvoicing.settings.contactName': 'Name',
  'einvoicing.settings.phone': 'Telefon',
  'einvoicing.settings.email': 'E-Mail',
  'einvoicing.settings.bank': 'Bankverbindung',
  'einvoicing.settings.iban': 'IBAN',
  'einvoicing.settings.bic': 'BIC',
  'einvoicing.settings.numberRange': 'Nummernkreis',
  'einvoicing.settings.prefix': 'Präfix',
  'einvoicing.settings.nextNumber': 'Nächste Nummer',
  'einvoicing.settings.saved': 'Einstellungen gespeichert',
};

export default einvoicing;
